import { render, staticRenderFns } from "./requestrrdview.vue?vue&type=template&id=5f84a685&scoped=true&"
import script from "./requestrrdview.vue?vue&type=script&lang=js&"
export * from "./requestrrdview.vue?vue&type=script&lang=js&"
import style0 from "./requestrrdview.vue?vue&type=style&index=0&id=5f84a685&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f84a685",
  null
  
)

export default component.exports